import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface CustomerOrderItem {

}

interface CustomerOrderItemState {
    data: CustomerOrderItem[];
    CustomerOrderItemData: CustomerOrderItem | null;
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_FOOD_ORDER_PORT;
const URL = import.meta.env.VITE_API_FOOD_ORDER_URL;



// Diet Mapping Code
export const fetchCustomerOrderItem = createAsyncThunk<CustomerOrderItem[], void, { rejectValue: string }>(
    'CustomerOrderItem/fetchCustomerOrderItem',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: CustomerOrderItem[] }>('/get_all_customer_order_item', PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createCustomerOrderItem = createAsyncThunk<CustomerOrderItem, any, { rejectValue: string }>(
    'CustomerOrderItem/createCustomerOrderItem',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: CustomerOrderItem }>('create_customer_order_item', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateCustomerOrderItem = createAsyncThunk<CustomerOrderItem, any, { rejectValue: string }>(
    'CustomerOrderItem/updateCustomerOrderItem',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: CustomerOrderItem }>('update_customer_order_item', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const customSearchCustomerOrderItem = createAsyncThunk<
    CustomerOrderItem[],
    { foodScheduleId: any },
    { rejectValue: string }
>(
    'CustomerOrderItem/customSearchCustomerOrderItem',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<any>(
                'custom_search_customer_order_item',
                PORT,
                URL,
                config
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);
// custom_search_customer_order_item
export const CustomerOrderItemSlice = createSlice({
    name: 'CustomerOrderItem',
    initialState: {
        data: [],
        CustomerOrderItemData: null,
        loading: false,
        error: null,
    } as CustomerOrderItemState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchCustomerOrderItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCustomerOrderItem.fulfilled, (state, action: PayloadAction<CustomerOrderItem[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCustomerOrderItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createCustomerOrderItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCustomerOrderItem.fulfilled, (state, action: any) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(createCustomerOrderItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateCustomerOrderItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCustomerOrderItem.fulfilled, (state, action: PayloadAction<CustomerOrderItem>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateCustomerOrderItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(customSearchCustomerOrderItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(customSearchCustomerOrderItem.fulfilled, (state, action: PayloadAction<CustomerOrderItem[]>) => {
                state.loading = false;
                state.CustomerOrderItemData = action.payload;
            })
            .addCase(customSearchCustomerOrderItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default CustomerOrderItemSlice.reducer;